/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

const Terms = ({ history }) => (
  <p
    style={{
      textAlign: 'center',
      marginTop: 40,
      fontSize: '0.9em',
      color: '#858585'
    }}
  >
    En continuant, vous acceptez les{'  '}
    <span
      style={{ color: '#2196f3', cursor: 'pointer' }}
      onClick={() => history.push('/terms/professional')}
    >
      Conditions générales de vente et d&lsquo;utilisation
    </span>
  </p>
);

Terms.propTypes = {
  history: PropTypes.object.isRequired
};

export default withRouter(Terms);
